
import { UserModule } from '~/store/modules/user';
import { Component, Vue } from 'vue-property-decorator';
import Field from '~/components/Field.vue';

@Component({
    components: {
        Field,
    },
})

export default class EmailSettings extends Vue {
    get emailSettings() {
        return UserModule.emailSettings;
    }

    get mailTypesSkipped() {
        return UserModule.mailTypesSkipped || [];
    }
}
